/**
 * A tagged template function that lets you interpolate JSX elements within a template string.
 *
 * @example
 * // Input:
 * inlineJsx`Click ${<a>here</a>} to win a ${<span class="font-bold">prize</span>}!`
 *
 * // Output:
 * <span>Click <a>here</a> to win a <span class="font-bold">prize</span>!</span>
 */
import { Fragment, type ReactNode } from "react"

export function inlineJsx(
  stringFragments: TemplateStringsArray,
  ...elements: ReadonlyArray<ReactNode | number | string>
): ReactNode {
  return (
    <span>
      {elements.map((element, index) => (
        <Fragment key={index}>
          {stringFragments[index]}
          {element}
        </Fragment>
      ))}
      {/* The `stringFragments` array is guaranteed to have exactly one more item than `elements`. */}
      {stringFragments.at(-1)}
    </span>
  )
}
